import React from 'react';
import PropTypes from 'prop-types';
import MainMenuItem from './mainMenuItem';
import appHistory from '../../utils/appHistory';
const DirectFormMenuItem = _ref => {
  let identifier = _ref.identifier,
    title = _ref.title,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'plus-circle' : _ref$icon,
    directFormType = _ref.directFormType;
  const handleClick = () => {
    appHistory.push("/directForms/new/".concat(directFormType));
  };
  return /*#__PURE__*/React.createElement(MainMenuItem, {
    className: "t-h-nav-".concat(identifier),
    key: "".concat(identifier, "Tab"),
    onClick: handleClick,
    glyph: icon,
    title: title
  });
};
DirectFormMenuItem.propTypes = {
  identifier: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  directFormType: PropTypes.string.isRequired
};
export { DirectFormMenuItem as TestDirectFormMenuItem };
export default DirectFormMenuItem;